import { setError } from 'features/error/slice';
import { toApiError } from 'libs/api/helper';

export function reportApiError(
  error: unknown,
  dispatch: (action: ReturnType<typeof setError>) => void
) {
  const apiError = toApiError(error);

  if (!apiError.isAbortedError) {
    dispatch(
      setError({ message: apiError.message, uiMessage: apiError.uiMessage })
    );
  }

  return apiError;
}
